import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { compose } from "redux";
import { t } from "i18next";

import shippingAddressApi from "../../api/shippingAddressApi";

import ReactTableBuilder from "../../utils/reactTableBuilder";
import { Box, Divider, IconButton } from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

import ShippingAddressForm from "./form/shippingAddressForm";
import { MuiButton } from "../../components/mui";
import { StandardPage, StandardPageTopContent, StandardPageMainContent, MuiCol, MuiRow, MuiBox } from "../../components/layout";
import { MuiSelect, ScannerInput, MuiTextArea, MuiTextField, MuiCheckbox } from '../../components/inputs';

function ShippingAddresses(props) {
  const { t } = props;
  const [shippingAddressesList, setShippingAddressesList] = useState([]);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [formValues, setFormValues] = useState({
    name:'',
    addressLabel:''
  });

  useEffect(()=>{
    loadShippingAddresses();
  },
  [])

  function loadShippingAddresses() {
    shippingAddressApi.getShippingAddresses().then((result) =>{
      if(result.data)
        setShippingAddressesList(result.data);
      else
       alert("ERROR");
    });
  }

  function onFormClose() {
    setIsFormOpen(false);
  }

  function onFormOpen() {
    setIsFormOpen(true);
  }

  function onNewShippingAddress() {
    setFormValues({
      shippingAddressId: undefined,
      name:'',
      addressLabel:''
    });
    onFormOpen();
  }

  function onEditShippingAddress(shippingAddress) {
    setFormValues({
      shippingAddressId:shippingAddress._id,
      name:shippingAddress.name,
      addressLabel:shippingAddress.addressLabel
    });
    onFormOpen();
  }

  function onDeleteShippingAddress(shippingAddress) {
    console.log(shippingAddress)
    shippingAddressApi.deleteShippingAddress(shippingAddress._id).then(()=>{
      loadShippingAddresses();
    })
    .catch((err)=>{
      alert('ERROR');
      console.log(err);
    })
  }

  function onFormSave(savedValues) {
    if(savedValues.shippingAddressId){
      shippingAddressApi.updateShippingAddress(savedValues.shippingAddressId,{
        name:savedValues.name,
        addressLabel:savedValues.addressLabel
      }).then(()=>{
        onFormClose();
        loadShippingAddresses();
      })
      .catch((err)=>{
        alert('ERROR');
        console.log(err);
      })
    } else {
      shippingAddressApi.addShippingAddress({
        name:savedValues.name,
        addressLabel:savedValues.addressLabel
      }).then(()=>{
        onFormClose();
        loadShippingAddresses();
      })
      .catch((err)=>{
        alert('ERROR');
        console.log(err);
      })
    }
    console.log('SEND TO BACKEND', savedValues);
  }

  const columns=[
    {
      Header: t('shipping_address.address_name'),
      accessor: 'name',
    },
    {
      Header: 'Action',
      accessor: (row, index)=>{
        return (
        <>
          <IconButton variant="contained" color="primary" aria-label="edit" onClick={()=>onEditShippingAddress(row)}>
            <EditIcon />
          </IconButton>
          <IconButton variant="contained" color="error" aria-label="delete" onClick={()=>onDeleteShippingAddress(row)}>
            <DeleteIcon />
          </IconButton>
        </>
        );
      },
    },
  ]

  const fakeData=[
    {
      name:"DC victo"
    }
  ]

  return (
    <>
      <StandardPage
        title={t("dashboard_main.shipping_addresses")}
      >
        <StandardPageTopContent>
          <MuiRow spacing={2} justifyContent="flex-end" sx={{marginBottom:"10px"}}>
            <MuiCol>
              <MuiButton onClick={onNewShippingAddress} large startIcon={<AddIcon />}>{t('shipping_address.new_address')}</MuiButton>
            </MuiCol>
          </MuiRow>
        </StandardPageTopContent>
        <StandardPageMainContent>
          <ReactTableBuilder columns={columns} data={shippingAddressesList} maxRows={9}/>
        </StandardPageMainContent>
      </StandardPage>
      <ShippingAddressForm isOpen={isFormOpen} onClose={onFormClose} onSave={onFormSave} values={formValues}/>
    </>
  );
}

ShippingAddresses.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors
});

export default compose(
  withTranslation(),
  connect(
    mapStateToProps,
  )
)(ShippingAddresses);